import React, { useState } from 'react';
import { Menu, Button } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  PieChartOutlined,
  DesktopOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { PREFIX_FRONT_URL } from '../consts';

// const {SubMenu} = Menu;
const MENUS = [window.c.routes.USER_SECURITY,
  window.c.routes.USER_COMMISSION_HISTORY,
  window.c.routes.WITHDRAW,
  window.c.routes.DEPOSIT,
  window.c.routes.DEPOSIT_WITHDRAWAL,
  window.c.routes.OPEN_ORDER,
  window.c.routes.ORDER_HISTORY,
  window.c.routes.ORDER_TRANS_HISTORY,
  window.c.routes.USER_LOGIN_HISTORY,
  window.c.routes.USER_WALLET];

export function WalletMenuComponent() {
  const [collapsed, setCollapsed] = useState(false);
  const [selectKeys, setSelectKeys] = useState([getKeyComponent(window.location) || window.c.routes.USER_WALLET]);
  const toggleCollapsed = () => setCollapsed(!collapsed);
  const history = useHistory();

  function getKeyComponent(location) {
    for (const menu of MENUS) {
      if (location.pathname.endsWith(menu)) {
        return menu;
      }
    }
    return window.c.routes.USER_WALLET;
  }

  history.listen((location, action) => {
    const keyComponent = getKeyComponent(location);
    setSelectKeys([keyComponent]);
  });

  return (
    <Translation>
      {(t) => (
        <div className="wallet-left-component">
          <Menu
            selectedKeys={selectKeys}
            mode="inline"
            theme="light"
            className="wallet-menu"
          >
            <Menu.Item
              key={`${window.c.routes.USER_WALLET}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.USER_WALLET}`)}
            >
              <div
                className="wallet-menu-icon"
              >
                <span className="icon-image-24" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.user_wallet')}</div>
            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.DEPOSIT}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.DEPOSIT}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-25" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.deposit')}</div>

            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.WITHDRAW}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.WITHDRAW}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-26-_1" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.withdrawal')}</div>

            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.DEPOSIT_WITHDRAWAL}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.DEPOSIT_WITHDRAWAL}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-27" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.deposit_history')}</div>

            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.OPEN_ORDER}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.OPEN_ORDER}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-28" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.open_orders')}</div>
            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.ORDER_HISTORY}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.ORDER_HISTORY}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-29" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.order_history')}</div>
            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.USER_COMMISSION_HISTORY}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.USER_COMMISSION_HISTORY}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-30" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.commission_history')}</div>
            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.ORDER_TRANS_HISTORY}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.ORDER_TRANS_HISTORY}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-30" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.order_trans_history')}</div>

            </Menu.Item>
            <Menu.Item
              key={`${window.c.routes.USER_LOGIN_HISTORY}`}
              className="wallet-menu-element"
              onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.USER_LOGIN_HISTORY}`)}
            >
              <div className="wallet-menu-icon">
                <span className="icon-image-30" />
              </div>
              <div className="text-normal fontW-700">{t('user.menu.user_login_history')}</div>
            </Menu.Item>
          </Menu>
        </div>
      )}
    </Translation>

  );
}

export default WalletMenuComponent;
